import { ActionPointRelation, UserTarget } from "../../../DTOs";
import { basicValidation } from "../basicValidation";

export const actionPointFieldValidation = {
    actionPoint: {
        id: (value: string) =>basicValidation.resourceId.isValid(value),
        relation: (value: ActionPointRelation) => validateActionPointRelation(value),
        description: (value: string) =>  basicValidation.resourceText.isValid(value, false, 200),
        assignedUser: (value: UserTarget | null) => validateUserTarget(value, true, false, true),
        assignedExternalUserName: (value: string) => validateUserExternalUserName(value),
        deadlineOrNone: (value: any) => basicValidation.dateOrNull(value)
    },
}

function validateUserTarget(user: UserTarget | null, allowNull?: boolean, allowEmptyName?: boolean, allowEmptyEmail?: boolean) {
    if (user === null) return allowNull || false;
    if (user === undefined) return false;
    if (!basicValidation.validateString(user.type, false, false, 0, 100)) return false;
    if (user.type === 'external') {
        if (!validateUserExternalUserName(user.fullName))
            return false;
        if (user.email === '') return allowEmptyEmail || false;
        if (!basicValidation.isValidEmail(user.email))
            return false;
        return basicValidation.validateString(user.role, false, false, 0, 50);
    }
    else if (user.type === 'internal') {
        return basicValidation.resourceId.isValid(user.userId);
    }
    else
        return false;
}

function validateUserExternalUserName(value: string)
{
    return basicValidation.validateString(value, false, false, 1, 50);
}

function validateActionPointRelation(value: ActionPointRelation) {
    if (value === null || value === undefined) return false;
    if (value.name === 'ActionPlanTopic')
        return basicValidation.resourceId.isValid(value.actionPlanTopicId);
    if (value.name === 'AgendaItem')
        return  basicValidation.resourceId.isValid(value.agendaItemId);
    return false;
}